
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import {getIPTVIRList, getIPTVRemoteIds} from "../../../api/kookong.js";

import {windVane} from "../../../utils/tmallGenius";
export default {
name: "iptvList",
components: {
Group,
Cell,
CellFormPreview,
CellBox,
Badge
},
data() {
return {
keyword: "",
list: [],
filteredList: []
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("请选择机顶盒品牌");
next();
},
created() {
const data = {
spId: this.$route.query.spId
};
getIPTVIRList(data).then(res => {
this.filteredList = res.data;
});
},
methods: {
async gotoPanel(item) {
const params = {
brandId: item.brandId
};
const res = await getIPTVRemoteIds(params);
this.$router.push({
path: "/device/tvbox",
query: {
bid: item.brandId,
kookongDeviceType: this.$route.query.kookongDeviceType,
uid: this.$route.query.uid,
deviceType: this.$route.query.deviceType,
deviceId: this.$route.query.deviceId,
rids: res.data.join(","),
aligenieZone: this.$route.query.aligenieZone,
spId: this.$route.query.spId,
areaId: this.$route.query.areaId,
spType: this.$route.query.spType // 判断是ipTV类型
}
});
}
}
};



// WEBPACK FOOTER //
// ./src/pages/device/tvBox/IptvList.vue